import Vue from 'vue'
import Router from "vue-router"
import app from './modules/app'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
    mode: 'history',
    scrollBehavior: () => ({y: 0}),
    routes: [{
        path: "/",
        component: (resolve) => require(['@/view/main.vue'], resolve),
        children: [{
            path: '/',
            component: (resolve) => require(['@/view/index/index.vue'], resolve),
        }, {
            path: '/Indent/index.html',
            component: (resolve) => require(['@/view/Indent/index.vue'], resolve),
        }, {
            path: '/Indent/terrace.html',
            component: (resolve) => require(['@/view/Indent/terrace.vue'], resolve),
        }, {
            path: '/Indent/own.html',
            component: (resolve) => require(['@/view/Indent/own.vue'], resolve),
        }, {
            path: '/Indent/list.html',
            component: (resolve) => require(['@/view/Indent/list.vue'], resolve),
        }, {
            path: '/Indent/terraceList.html',
            component: (resolve) => require(['@/view/Indent/terraceList.vue'], resolve),
        }, {
            path: '/Indent/ownList.html',
            component: (resolve) => require(['@/view/Indent/ownList.vue'], resolve),
        }, {
            path: '/Indent/complete.html',
            component: (resolve) => require(['@/view/Indent/complete.vue'], resolve),
        }, {
            path: '/Indent/unfinished.html',
            component: (resolve) => require(['@/view/Indent/unfinished.vue'], resolve),
        }, {
            path: '/Indent/return.html',
            component: (resolve) => require(['@/view/Indent/return.vue'], resolve),
        }, {
            path: '/Indent/dropShipping.html',
            component: (resolve) => require(['@/view/Indent/dropShipping.vue'], resolve),
        }, {
            path: '/Indent/forGoods.html',
            component: (resolve) => require(['@/view/Indent/forGoods.vue'], resolve),
        }, {
            path: '/Indent/completed.html',
            component: (resolve) => require(['@/view/Indent/completed.vue'], resolve),
        }, {
            path: '/Indent/send.html',
            component: (resolve) => require(['@/view/Indent/send.vue'], resolve),
        },
            {
                path: '/Credit/index.html',
                component: (resolve) => require(['@/view/Credit/index.vue'], resolve),
            },
            ...app
        ]
    }, {
        path: "/login.html",
        component: (resolve) => require(['@/view/login.vue'], resolve),
    }]
})

const whiteList = ['/login.html']

router.beforeEach((to, from, next) => {
    let token = localStorage.token
    let path = to.path.toLowerCase()
    if (token && path === '/login.html') {
        next({path: '/'})
    } else if (!token && whiteList.indexOf(path) === -1) {
        next({
            path: "/login.html",
            query: {
                redirect: to.fullPath
            }
        })
    } else {
        next()
    }
})

export default router
